
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { Message } from 'element-ui';
@Component
export default class systemConfigSet extends Vue {
    @Prop() chooseVisible: boolean;
    @Prop() currentInfo: any;

    @Getter ProductValueList: any;
    @Action('getProductValueList') getProductValueList: Function;
    @Action SaveSystemConfigSet: Function;
    @Action saveDefaultAssigneeByModule:Function;
    mounted() {
      //加载数据
      // const jsonObj = JSON.parse(this.currentInfo );
      // if (JSON.stringify(jsonObj) != '{}') {
      //   this.getProductValueList({ Code: this.currentInfo });
      // }
      

    //   this.$message({
    //     message: '打印的 obj 值: ' + JSON.stringify(this.ProductValueList),
    //     type: 'info'
    // });
  }
  @Watch('chooseVisible')
  watchOpenDialog(newVal: boolean, oldVal: boolean) {
        if (oldVal === false && newVal === true) {
            this.getProductValueList({ Code: this.currentInfo });
            // console.log("ssss",this.ProductValueList);

        //  this.$message({
        //         message: '打印的 obj 值: ' + JSON.stringify(this.ProductValueList.data),
        //         type: 'info'
        //  });

        }
    }

        // 关闭弹窗
     handleClose() {
        this.$emit('closeChooseVisible', false);
    }
        // 确认选择的条目
    confirmbtn() {


            //     this.$message({
            //    message: '打印的 obj 值: ' + JSON.stringify(this.ProductValueList.data),
            //     type: 'info'
            //  });
         let datas =this.ProductValueList.data;
        this.SaveSystemConfigSet({ configs: datas}).then(
        () => {
          this.$message.success('保存成功');
          this.$emit('closeChooseVisible', false);

        }
      );

    }
}
